import { render, staticRenderFns } from "./OTVideo2.vue?vue&type=template&id=3b10da64&"
import script from "./OTVideo2.vue?vue&type=script&lang=js&"
export * from "./OTVideo2.vue?vue&type=script&lang=js&"
import style0 from "./OTVideo2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports